import { Outlet } from 'react-router-dom';
import ProjectHeader from './ProjectHeader';
import PageBackBar from './PageBackBar';
import { useCompany } from '../contexts/CompanyContext';

/* ctAS customer-portal shell — same chrome as the staff app, with a
   "Portal" brand sub-label. Hub-and-spoke: no sidebar. */
export default function PortalLayout() {
  // Outside collaborators can't file tickets — they are not a customer of
  // this company, they were handed one specific ticket.
  const { currentCompany } = useCompany();
  const isGuest = !!(currentCompany as any)?.isGuest;
  return (
    <div className="scpa-shell">
      <ProjectHeader
        subLabel="Portal"
        homePath="/portal"
        profilePath="/portal/profile"
        ticketsPath="/portal/tickets"
        newTicketPath={isGuest ? undefined : '/portal/tickets/new'}
      />
      <PageBackBar />
      <div style={{ flex: 1, minHeight: 0, position: 'relative' }}>
        <div style={{ position: 'absolute', inset: 0, overflowY: 'auto' }}>
          <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100%', padding: '1rem clamp(0.75rem, 3vw, 1.5rem)' }}>
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}
